import Head from 'next/head';
import { WEBSITE_URL } from '@/constants/common';
import { getThumbnailUrl } from '@/utils/helper';
interface Props {
  name: string;
  description: string;
  videoLink: string;
  createdAt: string;
  contentUrl: string;
  userFullName: string;
}
const VideoSchema = ({
  name,
  description,
  videoLink,
  createdAt,
  contentUrl,
  userFullName
}: Props) => {
  const jsonld = {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: `${name}`,
    description: `${description}`,
    thumbnailUrl: [`${getThumbnailUrl(videoLink)}`],
    uploadDate: `${createdAt}`,
    embedUrl: `${videoLink}`,
    contentUrl: `${WEBSITE_URL}/${contentUrl}`,
    publisher: {
      '@type': 'Organization',
      name: `${userFullName}`,
      logo: {
        '@type': 'ImageObject',
        url: 'https://dehaat.in/assets/images/login-chacha.webp',
        width: '25',
        height: '25'
      }
    }
  };
  return <Head data-sentry-element="Head" data-sentry-component="VideoSchema" data-sentry-source-file="VideoSchema.tsx">
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(jsonld)
    }} />
    </Head>;
};
export default VideoSchema;